import { Header } from '@/components/layout/Header';
import { Hero } from '@/components/sections/Hero';
import { Philosophy } from '@/components/sections/Philosophy';
import { Meats } from '@/components/sections/Meats';
import { Fire } from '@/components/sections/Fire';
import { Experience } from '@/components/sections/Experience';
import { LocationSection } from '@/components/sections/LocationSection';
import { Gallery } from '@/components/sections/Gallery';
import { InstagramFeed } from '@/components/sections/InstagramFeed';
import { Reservation } from '@/components/sections/Reservation';
import { Footer } from '@/components/sections/Footer';
import { SEO } from '@/components/SEO';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocale } from '@/hooks/useLocale';

const Index = () => {
  const location = useLocation();
  const { t } = useTranslation('seo');
  const { locale } = useLocale();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, [location]);

  const restaurantStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Restaurant',
    name: 'Brace e Sapori',
    image: 'https://braceesapori.it/logo.png',
    '@id': 'https://braceesapori.it',
    url: 'https://braceesapori.it',
    telephone: '+393472916493',
    email: 'braceesapori@yahoo.com',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Via P. B. Moscatelli, 8',
      addressLocality: 'San Giorgio Ionico',
      postalCode: '74027',
      addressRegion: 'TA',
      addressCountry: 'IT',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 40.4564,
      longitude: 17.2036,
    },
    servesCuisine: 'Italian, Meat, BBQ',
    priceRange: '€€',
    openingHoursSpecification: [
      { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Saturday'], opens: '17:00', closes: '00:00' },
      { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Sunday'], opens: '09:00', closes: '00:00' },
      { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Monday'], opens: '10:30', closes: '00:30' },
      { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Tuesday'], opens: '17:00', closes: '00:00' },
      { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Thursday'], opens: '17:00', closes: '00:00' },
      { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Friday'], opens: '17:00', closes: '00:00' },
    ],
    aggregateRating: { '@type': 'AggregateRating', ratingValue: '4.8', reviewCount: '150' },
    sameAs: [
      'https://www.instagram.com/braceesapori/',
      'https://www.facebook.com/bracesaporibraceria/',
      'https://www.tiktok.com/@bracesapori',
    ],
    inLanguage: locale,
  };

  return (
    <main id="main-content" className="min-h-screen bg-background">
        <SEO
          title={t('home.title')}
          description={t('home.description')}
          keywords={t('home.keywords')}
          ogImage="/logo.png"
          logicalPath="/"
          structuredData={restaurantStructuredData}
        />
        <Header />
        <Hero />
        <section id="filosofia">
          <Philosophy />
        </section>
        <section id="carni">
          <Meats />
        </section>
        <section id="fuoco">
          <Fire />
        </section>
        <section id="menu">
          <Experience />
        </section>
        <LocationSection />
        <section id="galleria">
          <Gallery />
        </section>
        <InstagramFeed />
        <Reservation />
        <Footer />
    </main>
  );
};

export default Index;
